import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TrainingCentersService } from 'projects/services/src/app/API/training-centers.service';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { Location } from '@angular/common';
@Component({
	selector: 'app-message-centre',
	templateUrl: './message-centre.component.html',
	styleUrls: ['./message-centre.component.css']
	})
	export class MessageCentreComponent implements OnInit {
	emailMessages: any = [];
	actorName: any;
	appstageArray: any = [];
	actorType: any;
	@Input() trainingCentreId: any;
	stages: any = [];
	constructor(
		private router: Router,
		private trainingCentreService: TrainingCentersService,
		private currentUserService: CurrentUserService,
		private location: Location
	) { }

	ngOnInit() {
		this.currentUserService.getCurrentUser().subscribe(user => {
			this.actorName = user.userName;
			this.actorType = user.role;
			this.getAllStages();
			// this.getMessages();

		})
	}
	goBack() {
		// this.router.navigate(['/trainingcentre/training-of-trainers/tc-edit-caaf']);
		this.location.back();
	}

	getAllStages() {
		const emailmsg = []
		const tcId = this.trainingCentreId ? this.trainingCentreId : this.actorName;
			this.trainingCentreService.getApplicationStageList(tcId).subscribe(res => {
				if (res) {
					this.stages = res.stages;
					res.messages.forEach(function (obj, index) {
						if (obj.msg === '') {
							res.messages.splice(index, 1)
						} else {
							emailmsg.push(obj)
						}
					});

					this.emailMessages = emailmsg;

				}
			})
	}
}
